module.exports = __webpack_public_path__ + "static/media/slide-2.a267afd9.jpg";